export default  [
  {
    key: "id",
    label: "#",
  },
  {
    key: "owner_name",
    label: "Owner",
    sortable: true
  },

  {
    key: "contract_name",
    label: "Contract",
    sortable: true
  },

  {
    key: "device_name",
    label: "Device",
    sortable: true
  },

  {
    key: "plate_number",
    label: "Plate Number",
    sortable: true
  },


  {
    key: "date",
    label: "Date",
    sortable: true
  },

  {
    key: "shift_name",
    label: "shift",
    sortable: true
  },

  {
    key: "shift_start",
    label: "shift start",
    sortable: true
  },

  {
    key: "shift_end",
    label: "shift end",
    sortable: true
  },

  {
    key: "camp_leave_time",
    label: "camp leave",
    sortable: true
  },

  {
    key: "camp_back_time",
    label: "camp back",
    sortable: true
  },

  {
    key: "late_to_work_minutes",
    label: "late",
    sortable: true
  },

  {
    key: "work_after_shift_minutes",
    label: "after shift",
    sortable: true
  },

  {
    key: "total_stops_count",
    label: "stops count",
    sortable: true
  },

  {
    key: "areas",
    label: "details",
    sortable: false
  },

]